import { render, staticRenderFns } from "./UserOnboarding.vue?vue&type=template&id=5a8206c7&scoped=true&"
import script from "./UserOnboarding.vue?vue&type=script&lang=js&"
export * from "./UserOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./UserOnboarding.vue?vue&type=style&index=0&id=5a8206c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8206c7",
  null
  
)

export default component.exports